import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  FiHome, 
  FiUsers, 
  FiUserCheck,
  FiDatabase, 
  FiShield,
  FiMail // ✅ Import de l'icône pour les messages
} from 'react-icons/fi';
import './AdminSidebar.css';

function AdminSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // ✅ On récupère le rôle réel stocké lors de la connexion
  const userRole = localStorage.getItem('role'); 

  // 📋 Définition de tous les liens avec les rôles autorisés
  const menuItems = [
    { 
      label: 'Tableau de bord', 
      path: '/admin', 
      icon: FiHome, 
      roles: ['ADMIN', 'SUPER_ADMIN'] 
    },
    { 
      label: 'Messages Reçus', // ✅ Nouveau menu pour le formulaire de contact
      path: '/admin/messages', 
      icon: FiMail, 
      roles: ['ADMIN', 'SUPER_ADMIN'] 
    },
    { 
      label: 'Gestion des administrateurs', 
      path: '/admin/admins', 
      icon: FiShield, 
      roles: ['SUPER_ADMIN'] // 🔐 Réservé au Super Admin
    },
    { 
      label: 'Gestion des partenaires', 
      path: '/admin/partners', 
      icon: FiUserCheck, 
      roles: ['ADMIN', 'SUPER_ADMIN'] 
    },
    { 
      label: 'Gestion des clients', 
      path: '/admin/clients', 
      icon: FiUsers, 
      roles: ['ADMIN', 'SUPER_ADMIN'] 
    },
    { 
      label: 'Gestion des Produits', 
      path: '/admin/products', 
      icon: FiDatabase, 
      roles: ['ADMIN', 'SUPER_ADMIN'] 
    },
  ];

  // ✅ Filtrage intelligent : on ne garde que les menus autorisés pour cet utilisateur
  const filteredLinks = menuItems.filter(item => item.roles.includes(userRole));

  return (
    <aside className="admin-sidebar">
      <div>
        {/* Titre avec badge de rôle pour un aspect pro */}
        <h3 className="sidebar-brand">S2i Admin</h3>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
            <span className={`role-badge ${userRole === 'SUPER_ADMIN' ? 'super' : 'simple'}`}>
                {userRole === 'SUPER_ADMIN' ? 'SUPER ADMIN' : 'GESTIONNAIRE'}
            </span>
        </div>

        <ul className="sidebar-menu">
          {filteredLinks.map((link) => (
            <li
              key={link.path}
              className={`menu-item ${location.pathname === link.path ? 'active' : ''}`}
              onClick={() => navigate(link.path)}
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') navigate(link.path); }}
            >
              <div className="sidebar-icon">
                <link.icon size={20} />
              </div>
              <span className="sidebar-label">{link.label}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="sidebar-footer">
        <p>Espace Sécurisé S2I</p>
        <p style={{ fontSize: '0.65rem', opacity: 0.7 }}>v1.0.0 Stable</p>
      </div>

      {/* Styles additionnels intégrés */}
      <style>{`
        .sidebar-brand {
            text-align: center;
            padding: 20px 0;
            font-weight: 800;
            color: #d90000;
            text-transform: uppercase;
            letter-spacing: 2px;
        }
        .sidebar-menu {
            list-style: none;
            padding: 0;
            margin: 0;
        }
        .menu-item {
            display: flex;
            align-items: center;
            padding: 12px 20px;
            margin: 4px 15px;
            border-radius: 12px;
            cursor: pointer;
            transition: all 0.3s ease;
            color: #64748b;
        }
        .menu-item:hover {
            background: #f8fafc;
            color: #d90000;
        }
        .menu-item.active {
            background: #fee2e2;
            color: #d90000;
            font-weight: 600;
        }
        .sidebar-icon {
            margin-right: 15px;
            display: flex;
            align-items: center;
        }
        .role-badge {
            font-size: 0.65rem;
            padding: 4px 10px;
            border-radius: 20px;
            font-weight: 800;
            letter-spacing: 1px;
            text-transform: uppercase;
        }
        .role-badge.super {
            background: rgba(217, 0, 0, 0.1);
            color: #d90000;
            border: 1px solid #d90000;
        }
        .role-badge.simple {
            background: rgba(33, 150, 243, 0.1);
            color: #1565c0;
            border: 1px solid #1565c0;
        }
        .sidebar-footer {
            margin-top: auto;
            padding: 1.5rem;
            text-align: center;
            border-top: 1px solid rgba(0,0,0,0.05);
            color: #94a3b8;
        }
      `}</style>
    </aside>
  );
}

export default AdminSidebar;